import styled from "styled-components";
import Button, { ButtonThemes } from "../../Button/Button";
import { TopNavbarMenuButton } from "../../../modules/AIHumans/components/TopNavbar";
interface PopupHeaderProps {
  menuButtonAction?: () => void;
  noPreviousButton?: boolean;
  handlePreviousButton?: () => void;
  handleNextButton?: () => void;
  disableNextButton?: boolean;
}
const PopupHeader = ({
  menuButtonAction,
  noPreviousButton = false,
  handlePreviousButton,
  handleNextButton,
  disableNextButton = false,
}: PopupHeaderProps) => {
  return (
    <Wrapper>
      <TopNavbarMenuButton action={menuButtonAction} />

      <ButtonsWrapper>
        {!noPreviousButton && (
          <Button
            className="previous-step-button"
            buttonTheme={ButtonThemes.Outline}
            disabled={false}
            text="Previous"
            onClick={handlePreviousButton}
          />
        )}
        <Button
          className="next-step-button"
          buttonTheme={ButtonThemes.Primary}
          disabled={disableNextButton}
          text="Next"
          onClick={handleNextButton}
        />
      </ButtonsWrapper>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  background-color: #0e0d0d;
  color: #ffffff;
  position: fixed;
  top: 0;
  width: 100%;
  height: 51px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  z-index: 101; // same as popup modal
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  & button > span {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
  }
  .previous-step-button {
    width: 79px;
    height: 34px;
    padding: 7px 10px;
    border-radius: 5px;
  }
  .next-step-button {
    width: 64px;
    height: 34px;
    padding: 7px 16px;
    border-radius: 5px;
  }
`;
export default PopupHeader;
